module.exports = __webpack_public_path__ + "img/journal.6094430c.jpeg";